import React from "react";
// import React, { useState, useEffect, useLayoutEffect } from "react";
// import Log from "../utils/Log";
// import { useSelector, useDispatch } from "react-redux";
import styles from "../styles/ReportAnIssue.module.scss";
// import QueryString from "query-string";
// import Login from "./Login";
// import { ssoTokenLogin } from "../actions/auth";
// import currentUserInfo from "../selectors/currentUserInfo";
// import Spinner from "../components/Spinner";
// import { redirectToLoginPage } from "../utils/routes";
import classnames from "classnames";

// TODO: Read through this and see why this existed before
// before this was using monkey survey? so it required a user to be logged in to fill in the form
export default function ReportAnIssue() {
  // const dispatch = useDispatch();
  // const currentUser = useSelector(currentUserInfo);
  // const currentState = useSelector(
  //   (state) => state.current.workState.loginState
  // );

  // const currentUrl = new URL(window.location);
  // const urlQuery = QueryString.parse(currentUrl.search);

  // const [hasBuildInfo, setHasBuildInfo] = useState(false);
  // const [userEmail, setEmail] = useState("");
  // const [bbVersion, setBbVersion] = useState("");
  // const [operatingSytem, setOperatingSystem] = useState("");
  // const [buildNumber, setBuildNumber] = useState("");
  // const [isLoading, setIsLoading] = useState(true);

  // const spinnerStyle = {
  //   height: "50px",
  //   width: "50px",
  // };

  // async function onLoad() {
  //   sessionStorage.setItem("previousRoute", "/reportAnIssue");

  //   if (urlQuery["OS"] && urlQuery["buildNumber"] && urlQuery["version"]) {
  //     const OS = urlQuery["OS"];
  //     const buildNumber = urlQuery["buildNumber"];
  //     const bbVersion = urlQuery["version"];
  //     setOperatingSystem(OS);
  //     setBuildNumber(buildNumber);
  //     setBbVersion(bbVersion);
  //     setHasBuildInfo(true);
  //     sessionStorage.setItem("OS", OS);
  //     sessionStorage.setItem("buildNumber", buildNumber);
  //     sessionStorage.setItem("version", bbVersion);
  //   }

  //   if (urlQuery["token"]) {
  //     const token = urlQuery["token"];

  //     try {
  //       await dispatch(ssoTokenLogin(token, false));
  //     } catch (e) {
  //       Log.error(e, "Error caught: /sso login");
  //     }
  //   }
  // }

  // useLayoutEffect(() => {
  //   onLoad();
  // }, []);

  // useEffect(() => {
  //   if (currentState === "Loading") {
  //     setIsLoading(true);
  //   } else {
  //     // handles the split second where we are no longer loading, and currentUser has not been updated yet
  //     setTimeout(() => {
  //       setIsLoading(false);
  //     }, 300);
  //   }
  // }, [currentState]);

  // useEffect(() => {
  //   if (currentUser) {
  //     setEmail(currentUser.email);
  //   } else {
  //     redirectToLoginPage(props);
  //   }
  // }, [currentUser]);

  // useEffect(() => {
  //   window.scrollTo(500, 0);
  // });

  return (
    <div className={styles.wrapper}>
      {/* <img
        src="https://frontend-assets.buildbox.com/Bug_60x60px_x2.png"
        className={styles.icon}
      /> */}
      <div className={styles.header}>
       <p className={styles.title}>Report An Issue</p>
       <p className={styles.subTitle}>Submit your issue to our support team and we'll try to help you.</p>
      </div>
      <div className={styles.content}>
      Please tell us about your issue. Try to be as descriptive as possible and post any files that might help us address the issue you are experiencing.
       <a href={`mailto:support@buildbox.com`} className={styles.emailBtn}>
          <button className={classnames(styles.buttonRegularOrange, styles.emailBtn)}>
            <h3>Email Support</h3>
          </button>
       </a>
      </div>
      {/* {isLoading ? (
        <div className={styles.spinnerWrapper}>
          <Spinner isLoading={isLoading} spinnerStyle={spinnerStyle} />
        </div>
      ) : (
        <>
          <div className={styles.subText}>
            Please tell us about your issue. Try to be as descriptive as
            possible and post any files that might help us address the issue you
            are experiencing.
          </div>
          <div
            id={
              hasBuildInfo
                ? styles.formWrapperWithBuildInfo
                : styles.formWrapperWithoutBuildInfo
            }
          >
            <div id="smcx-sdk" className={styles.form}></div>
            <iframe
              src={
                hasBuildInfo
                  ? `https://www.surveymonkey.com/r/K3GMYZC?email=${userEmail}&OS=${operatingSytem}&buildNumber=${buildNumber}&version=${bbVersion}`
                  : `https://www.surveymonkey.com/r/RZ9NDYP?email=${userEmail}`
              }
              title="Report An Issue"
              className={styles.iframeWrapper}
              id="formFrame"
            ></iframe>

          </div>
        </>
      )}  */}
    </div>
  );
}
